import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesSort'
})
export class FilesSortPipe implements PipeTransform {

  transform(array: any): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a.attributes[0].value < b.attributes[0].value) {
        return -1;
      } else if (a.attributes[0].value > b.attributes[0].value) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

}
